const topics = [
  { name: '久久视频', hot: true, count: '1280+' },
  { name: '芒果视频', hot: true, count: '960+' },
  { name: '97视频', hot: true, count: '850+' },
  { name: '丝瓜视频', hot: false, count: '720+' },
  { name: '蓝莓视频', hot: false, count: '650+' },
  { name: '91在线视频', hot: true, count: '580+' },
  { name: '视频播放器', hot: false, count: '510+' },
  { name: '在线看视频', hot: false, count: '490+' },
  { name: '视频资源', hot: false, count: '440+' },
  { name: '在线视频网站', hot: true, count: '420+' },
  { name: '视频导航', hot: false, count: '380+' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          久久视频、芒果视频、97视频等在线视频网站相关话题热度与资源动态一览
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <div
              key={i}
              className="group flex items-center gap-3 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <span className="text-sm font-semibold text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              {topic.hot && (
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                  <i className="ri-fire-line text-xs"></i>热门
                </span>
              )}
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}